import { useEffect, useRef, useState } from 'react'

const useAnyElementInViewport = (ids = [], headerHeight = 0) => {
  const [isAnyElementInViewport, setIsAnyElementInViewport] = useState(false)
  const elementsRef = useRef([])

  // Resolve element IDs to DOM references once, cache in a ref
  useEffect(() => {
    elementsRef.current = ids.map((id) => document.getElementById(id)).filter(Boolean)
  }, [ids])

  useEffect(() => {
    const elements = elementsRef.current
    if (elements.length === 0) return

    // A callback only reports the elements whose intersection changed, so keep the state of
    // every observed element to answer for the whole set
    const intersectionByElement = new Map(elements.map((element) => [element, false]))

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => intersectionByElement.set(entry.target, entry.isIntersecting))
        setIsAnyElementInViewport([...intersectionByElement.values()].some(Boolean))
      },
      {
        root: null,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 0,
      }
    )

    elements.forEach((element) => observer.observe(element))

    return () => {
      elements.forEach((element) => observer.unobserve(element))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids, headerHeight])

  return isAnyElementInViewport
}

export { useAnyElementInViewport }
